import { render, staticRenderFns } from "./PidDashRecentActivity.vue?vue&type=template&id=57748c90&scoped=true&"
import script from "./PidDashRecentActivity.vue?vue&type=script&lang=js&"
export * from "./PidDashRecentActivity.vue?vue&type=script&lang=js&"
import style0 from "./PidDashRecentActivity.vue?vue&type=style&index=0&id=57748c90&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57748c90",
  null
  
)

export default component.exports